import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Grid, Typography } from '@material-ui/core';

import useStyles from './styles';

import SelectorServicio from './SelectorServicio';

//actions
import {
  // viajeDeVueltaActivaAction,
  setSelectedServicioIda,
} from '../../redux/actions/serviciosActions';

const TabServiciosIda = ({ setTabIndex }) => {
  const classes = useStyles();

  const servicios = useSelector((state) => state.servicios.servicios.ida);
  const servicioSelected = useSelector(
    (state) => state.servicios.serviciosSeleccionados.ida
  );

  // const dispatch = useDispatch();

  // const handleViajeVuelta = () => {
  //   setTabIndex(2);
  //   dispatch(viajeDeVueltaActivaAction());
  // };

  return (
    <Fragment>
      <Grid container spacing={1} className={classes.container}>
        <Grid item xs={12} md={12}>
          <Typography variant='h6' className={classes.widthTitle}>
            Seleccioná el mejor servicio para vos
          </Typography>
        </Grid>
        {/* <Grid item xs={12} md={4}>
          {servicioSelected && (
            <Button
              variant='contained'
              color='secondary'
              fullWidth
              onClick={handleViajeVuelta}
              className={classes.button}
            >
              Agregar viaje de vuelta?
            </Button>
          )}
        </Grid> */}
        <SelectorServicio
          servicios={servicios}
          servicioSelected={servicioSelected}
          selectedServicioRedux={setSelectedServicioIda}
        />
      </Grid>
    </Fragment>
  );
};

export default TabServiciosIda;
//
